import { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Appearance as AppearanceType } from '@/types';
import { trackFeature } from '@/utils/adobeLaunch';
import { switchAppearanceWithConfirmationAction } from '@/redux/draft/actions/switchAppearanceWithConfirmationAction';
import { getAppearancesForCurrentProductType } from '@/redux/draft/getters/getAppearancesForCurrentProductType';
import { getCurrentAppearance } from '@/redux/draft/getters/getCurrentAppearance';
import { StoreDispatch } from '@/redux/types';
import { Appearance } from '@/components/common/Appearance';
import './ProductTypeAppearances.scss';

export const ProductTypeAppearances: FunctionComponent = () => {
  const dispatch = useDispatch<StoreDispatch>();
  const availableAppearances = useSelector(getAppearancesForCurrentProductType);
  const currentAppearance = useSelector(getCurrentAppearance);

  const handleAppearanceSelect = (appearance: AppearanceType) => {
    trackFeature('appearance-select');
    dispatch(switchAppearanceWithConfirmationAction(appearance));
  };

  if (availableAppearances.length === 0) {
    return null;
  }

  return (
    <div className="product-type-appearances">
      <div className="product-type-appearances__list" role="listbox">
        {availableAppearances.map((a) => (
          <Appearance
            key={a.id}
            appearance={a}
            selected={currentAppearance.id === a.id}
            onClick={handleAppearanceSelect}
          />
        ))}
      </div>
    </div>
  );
};
